import api from './index';
//
let exports = {};

exports.getDevcMaintProofListByFilter = function (data, callback) {
    api.post('/devc/maint/proof/list/get/by/filter')
        .data(data)
        .done(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcMaint.js
// module id = 1546
// module chunks = 1